import AxiosClient from './AxiosClient';
import { appSettings } from '../settings';
import ApiUrl from '../services/APIUrl';
import { handleSuccess } from '../services/DataHelperFunctions';

import type { IUserDetails } from '../../types/IRequestTypes';

export const UserApi = {
  // This api call will returns the logged in user details from the DB
  getLoggedInUserDetails: (action: IUserDetails) => {
    return AxiosClient.get(ApiUrl.ReadUserDetails, {
      baseURL: appSettings.DisEndpoint,
      headers: { Authorization: `Bearer ${action.token}` },
    })
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return { error: err };
      });
  },
};
